import { create } from "zustand";
import {
  downloadDocApi,
  getAllPosApi,
  getIRNList,
  getPeriodsApi,
  getSettingsApi,
  getStoresByUserId,
  printDetailByIrnApi,
  uploadDocApi,
} from "../services/irn";

export const useIrnStore = create((set) => ({
  irnList: [],
  period: "",
  fromDate: "",
  toDate: "",
  periods: [],
  settings: {},
  allPos: [],
  stores: [],
  // Actions
  getIrns: async (from, to) => {
    try {
      const response = await getIRNList(from, to);
      const formattedData = response?.Data?.map((element, index) => ({
        ...element,
        serialNo: index + 1,
      }));
      set({ irnList: formattedData || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },
  getAllPos: async (from, to, status) => {
    try {
      const response = await getAllPosApi(from, to, status);
      const formattedData = response?.Data.map((element, index) => ({
        ...element,
        serialNo: index + 1,
      }));
      set({ allPos: formattedData || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },
  getPeriods: async () => {
    try {
      const response = await getPeriodsApi();
      set({ periods: response?.Data || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },
  getStore: async () => {
    try {
      const response = await getStoresByUserId();
      set({ stores: response?.Data || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },
  getSettings: async (id) => {
    try {
      const response = await getSettingsApi(id);
      set({ settings: response?.Data || {} });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },
  uploadDoc: async (data) => {
    try {
      const response = await uploadDocApi(data);
      return response?.Data;
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },
  downloadDoc: async (name) => {
    try {
      const response = await downloadDocApi(name);
      return response;
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },
  getPrintDetailByIrn: async (irn) => {
    try {
      const response = await printDetailByIrnApi(irn);
      return response?.Data;
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },
  reset: () => set({ count: 0 }),
}));
